
import { GoogleLogin } from '@react-oauth/google';
import api from '../api/axois'; // your axios setup
import { useNavigate } from 'react-router-dom';


import { useUser } from '../context/UserContext';

function GoogleLoginButton() {
    const navigate = useNavigate();
    const { setUser } = useUser();
    const handleSuccess = async (credentialResponse) => {
        const token = credentialResponse.credential;
        try {
            // Send only the Google token to backend
            const response = await api.post('/auth/google/callback', { token });
            let { user, token: apiToken } = response.data;
            // Normalize user object for first_name and last_name
            if (user && (!user.first_name || !user.last_name)) {
                if (user.name) {
                    const nameParts = user.name.split(' ');
                    user.first_name = user.first_name || nameParts[0] || '';
                    user.last_name = user.last_name || nameParts.slice(1).join(' ') || '';
                }
            }
            localStorage.setItem('token', apiToken);
            localStorage.setItem('user', JSON.stringify(user));
            setUser(user);
            // Redirect to profile page after successful login
            navigate('/ProfilePage');
        } catch (err) {
            alert('Google login failed: ' + (err.response?.data?.error || err.message));
        }
    };

    const handleError = (error) => {
        alert('Google Sign In Failed');
    };

    return (
        <div>
            <GoogleLogin
                onSuccess={handleSuccess}
                onError={handleError}
                useOneTap={false}
                auto_select={false}
                cancel_on_tap_outside={true}
                theme="outline"
                size="large"
                render={renderProps => (
                    <button onClick={renderProps.onClick} disabled={renderProps.disabled}>
                        Sign in with Google
                    </button>
                )}
            />
        </div>
    );
}

export default GoogleLoginButton;
